import { Breakpoints as m } from "../../style/base/index.js";
import { convertToHtmlId as P } from "../../utils/convert-to-html-id.js";
const h = m.LARGE, I = ["Phase 1", "Phase 2", "Phase 3", "Filed", "Approved"], E = new Set(I), L = {
  "Phase 1": "P1",
  "Phase 2": "P2",
  "Phase 3": "P3",
  Filed: "Fil.",
  Approved: "App."
}, f = I.map((e) => ({
  id: P(e),
  label: e,
  shortLabel: L[e]
})), A = (e, r) => {
  const o = {};
  for (const n of e) {
    const t = r(n);
    if (!E.has(t))
      continue;
    const i = P(t);
    o[i] = (o[i] ?? 0) + 1;
  }
  return o;
}, l = (e, r, o) => {
  const n = /* @__PURE__ */ new Map();
  for (const t of e) {
    const i = o(t);
    if (!E.has(i))
      continue;
    const c = r(t), a = P(c), p = P(i);
    let s = n.get(a);
    s || (s = { id: a, label: c, items: [], itemsByLaneId: {} }, n.set(a, s)), s.items.push(t), s.itemsByLaneId[p] || (s.itemsByLaneId[p] = []), s.itemsByLaneId[p].push(t);
  }
  return Array.from(n.values());
};
export {
  f as PIPELINE_LANES,
  h as PIPELINE_MOBILE_BREAKPOINT,
  I as PIPELINE_PHASE_ORDER,
  A as countPipelineItemsByLane,
  l as groupPipelineItems
};
